import { observer } from "mobx-react-lite";
import { ModalAside, ModalAsideHeader } from "../components/ModalAside";
import { Button } from "../components/Button";
import Collapse from "../components/Collapse";
import FabricCard from "../components/FabricCard";
import ColorCard from "../components/ColorCard";
import Select2 from "../components/Select2";
import DetailBar, { DetailBarStripe } from "../components/DetailBar";
import SampleCard from "../components/SampleCard";
import { Modal } from "../components/Modal";
import SimpleSwitch from "../components/SimpleSwitch";
import PlusIcon from "../icons/PlusIcon";
import { store } from "../stores/Store";
import { useWindowSize } from "../effects/useWindowSize";
import Checkbox from "../components/Checkbox";
import SavingModal from "./SavingModal";
import { BREAKPOINT_LG, BREAKPOINT_MD } from "../stores/constants";
import FiltersFabrics from "../components/FIltersFabrics";
import ComparisionCard from "../components/ComparisionCard";
import InfoBar from "../components/InfoBar";
import { publicUrl } from "../utils/url";
import { _t } from '../utils/Lang';
import SummaryModal from "./SummaryModal";
import SizeTable, { SizeTableHeader, SizeTableLabel } from "../components/SizeTable";
import SliderModal from "./SliderModal";
import MattressDetailModal from "./MattressDetailModal";
import CartSummaryModal from "./CartSummaryModal";


import PreviewModal from "./PreviewModal";
import TechnicalCardModal from "./TechnicalCardModal";
import FabricCollectionModel from "../models/FabricCollectionModel";
import DimensionsModal from './modal/DimensionsModal.jsx';
import BackDimensionsModal from "./modal/BackDimensionsModal.jsx";
import QuizModal from "./QuizModal.jsx";
import ProductModel from "../stores/ProductModel.js";
import MattressComparisionModal from "./MattressComparisionModal.jsx";
import { Gtm } from "../utils/Gtm.js";
import { Clarity } from "../utils/Clarity.js";





const Modals = observer(() => {
    const windowSize = useWindowSize();
    const canShowHeader = windowSize.width >= BREAKPOINT_MD;
    const category: FabricCollectionModel = store.selectedCategory;

    var fabricCard = <FabricCard
        className='no-border'
        hideSwatch={true}
        bestseller={true}
        imageUrl={category?.thumbUrl}
        attributes={category?.fabricFeatures.map(f => f.name)}
        properties={category?.fabricProperties}
        name={category?.name}
        price={category?.price}

        documentationLink={category?.pdfUrl}

    />
    var card = null;
    if (windowSize.width < 1024) {
        card = <Collapse className='Collapse--gray'
            // isOpen={true}
            title={({ open }) => {
                return <div className="d-flex w-100 py-1">
                    <div className='w-50 truncate'>
                        {_t('selected_fabric')}: {store.selectedFabric?.name}
                    </div>
                    <div className="w-50 d-flex j-end a-center">
                        {!open ? _t('expand_details') : _t('collapse_details')}
                        <svg className='Collapse__arrow' width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.3078 0.999867L6 6.30762L0.692249 0.999867L1.4 0.292117L6 4.89212L10.6 0.292117L11.3078 0.999867Z" fill="#1F1F1F" />
                        </svg>

                    </div>
                </div>
            }}>
            <div className="mt-3 mb-1">

                {fabricCard}
            </div>
        </Collapse>
    } else {
        card = fabricCard
    }

    return <>

        {/* fabric category / select color */}
        <ModalAside

            isOpen={store.isFabricCategoryOpen}
            onClose={store.closeFabricCategory}
            header={canShowHeader ? <ModalAsideHeader showCloseBtn={false} onClose={store.closeFabricCategory} /> : null}
            footer={<div className='d-flex py-2 paddings-x a-center'>
                <div className="w-50">
                    <div className="fw-500">{_t('selected_fabric')}</div>
                    {store.selectedFabric?.name}
                </div>
                <div className="w-50 text-end">
                    <Button
                        onClick={() => {
                            Gtm.setStore(store);
                            Gtm.push({
                                event: "konfigurator_click",
                                ecommerce: {
                                    button_name: "zapisz i przejdź dalej",
                                    button_typ: "szczegol",
                                    option: Gtm.getSelectedFabricStr(),
                                    etap: 2,
                                    value: Gtm.getPrice(),
                                    items: [
                                        {
                                            item_name: Gtm.getProductName(),
                                            item_id: Gtm.getProductId(),
                                            item_brand: "MyBed",
                                            item_category: "Łóżka",
                                            item_variant: Gtm.getVariantStr(),
                                        }
                                    ]
                                }
                            });
                            Clarity.push("konfigurator_click - szczegol - zapisz i przejdź dalej");
                            store.closeFabricCategory(null, { tracking: false });
                            const step = store.getNextStep('fabric_component');
                            store.scrollTo(step.typeId);




                        }}
                        className="primary w-100 w-lg-auto ms-lg-auto">{_t('save_and_continue')}</Button>
                </div>
            </div>}
        >
            <div className="creators-controls">


                {card}


                <div className="c-h3 mt-4">{_t('select_color')}</div>
                <div className="d-grid g-2 grid-cols-3 grid-cols-md-4 pb-5">
                    {
                        store.selectedCategory?.fabricsFiltered.map((item, index) => {
                            return <ColorCard
                                data={{ optionId: item.optionId, valueId: item.valueId }}
                                colorName={item.colorGroup?.name}
                                key={index}
                                name={item.name}
                                imageUrl={item.imageUrl}
                                showChecked={true}
                                checked={store.selectedFabricId === item.valueId}
                                onClick={() => {
                                    store.selectFabric(item.valueId)
                                    store.updateOption(item.optionId, item.valueId, { tracking: false });
                                }}
                            />
                        })
                    }

                </div>

            </div>
        </ModalAside>


        {/* Próbnik / step 1 / Zamów próbki tkanin */}
        <ModalAside
            className='ModalAside--full'
            isOpen={store.isSwatchesOpen}
            onClose={store.closeSwatches}
            header={canShowHeader ? <ModalAsideHeader
                title={_t('order_samples')}
                titleSm={_t('close_and_return')}
                closeText={_t('close_and_return')}
                showBackBtn={false}
                onClose={store.closeSwatches} /> : null}
            zIndex={30}
        >
            <div className="creators-controls">




                {/* <div className="c-h3 mt-4">Wybierz kolor</div> */}
                <FiltersFabrics mode='swatches' filtersStore={store.fabricFilters} />

                {store.fabricCollectionFiltered.length < 1 && <InfoBar className="w-100">
                    {_t('no_results')}
                </InfoBar>}

                <div className="d-grid g-2 grid-cols-1 grid-cols-md-2 pb-8">
                    {
                        store.fabricCollectionFiltered.map((item, index) => {
                            return <FabricCard
                                key={index}
                                data={{ id: item.id, optionId: item.optionId }}
                                // imageUrl={item.thumbUrl}
                                imageUrl={item.filteredImageURL(store.fabricFilters.getFilterValue('colors'))}

                                hideSwatch={true}
                                bestseller={index === 0}
                                badge={item.badge}

                                onClick={() => {
                                    store.openSwatchesCategory(item)
                                }}
                                name={item.name}
                                price={item.price}
                                attributes={item.fabricFeatures.map((f) => f.name)}
                                properties={item.fabricProperties}
                                showChecked={false}
                            />
                        })
                    }

                </div>

            </div>
        </ModalAside>

        {/* Próbnik / step 2 */}
        <ModalAside
            className='ModalAside--full'
            isOpen={store.isSwatchesCategoryOpen}
            onClose={store.closeSwatchesCategory}
            header={canShowHeader ? <ModalAsideHeader

                title={_t('order_samples')}
                titleSm={_t('close_and_return')}
                closeText={_t('close_and_return')}
                showBackBtn={false}
                onClose={store.closeSwatchesCategory}
            /> : null}
            zIndex={31}
        >
            <div className="creators-controls">




                <FiltersFabrics filtersStore={store.fabricFilters} hideSorting={true} hideProperties={true} />


                <div className="d-grid g-2 grid-cols-3 grid-cols-md-4 grid-cols-lg-6" style={{ paddingBottom: 150 }}>
                    {
                        store.selectedSwatches.filteredSwatches.map((item, index) => {
                            return <SampleCard
                                key={index}
                                name={item.name}
                                imageUrl={item.imageUrl}

                                onExpandClick={() => {
                                    store.openPreview(item.imageUrl, 'md', '1');
                                }}
                                onClick={async () => {
                                    if (store.selectedSwatches.includes(item)) {
                                        await store.selectedSwatches.removeSwatch(item);
                                    } else {
                                        await store.selectedSwatches.addSwatch(item);

                                    }
                                }}
                                checked={store.selectedSwatches.includes(item)}
                                showChecked={false}
                            />
                        })
                    }

                </div>

            </div>
        </ModalAside>

        {/* dimensions popup */}
        <DimensionsModal />


        {/* Back dimensions popup */}
        <BackDimensionsModal />


        {/* Mattress comparision */}
        <MattressComparisionModal />

        {/* Pojedynczy/podwójny materac - Jak wybrać? */}
        <Modal
            className="modal"
            onClose={e => {
                store.closeMattressType();
            }}
            isOpen={store.isMattressTypeOpen}

        >
            <div className="ModalComparision">
                <div className='c-h2 mb-1'>{_t('mattress_type_title')}</div>
                <p className="c-p-bigger">{_t('mattress_type_guide')}</p>
                {/* <div className="c-p fw-bold">Sprawdź jak wygląda wybrana wysokość wezgłowia</div> */}
                {/* <p>Poradnik jak wybrać</p> */}
                <div className="d-grid g-4 grid-cols-1 grid-cols-md-2">
                    <div>
                        <img src={publicUrl('/assets/double-m-new.png')} style={{ aspectRatio: '16/9', objectFit: 'contain' }} className="d-block m-auto" alt="" />
                        <p className="fw-500 mt-2 mb-2">{_t('two_mattress_for')}</p>
                        <p className="color-lightgray">
                            {_t('two_mattress_desc')}
                        </p>

                    </div>
                    <div>
                        <img src={publicUrl('/assets/single-m-new.png')} style={{ aspectRatio: '16/9', objectFit: 'contain' }} className="d-block m-auto" alt="" />
                        <p className="fw-500 mt-2 mb-2">{_t('one_mattress_for')}</p>
                        <p className="color-lightgray">
                            {_t('one_mattress_desc')}
                        </p>

                    </div>

                </div>

            </div>


        </Modal>

        {/* Twardość - jaką wybrać? */}
        <Modal
            className="modal"
            onClose={e => {
                store.closeHardnessPopup();
            }}
            isOpen={store.isHardnessOpen}

        >
            <div className="ModalComparision">
                <div className='c-h1 mb-3'>{_t('hardness_title')}</div>
                {/* <p>Poradnik jak wybrać</p> */}
                <p className="">
                    <b>{_t('hardness_subtitle')}</b>
                    {_t('hardness_desc')}
                </p>


                <div className="d-flex g-2 mb-3">
                    <SizeTableLabel bgcolor="#F2F3F6">
                        {_t('hardness_h2')}
                    </SizeTableLabel>
                    <SizeTableLabel bgcolor="#98A6BD">
                        {_t('hardness_h3')}
                    </SizeTableLabel>
                    <SizeTableLabel bgcolor="#2C2D50" color="#fff">
                        {_t('hardness_h4')}
                    </SizeTableLabel>
                </div>
                <div className="d-grid g-4 grid-cols-1 grid-cols-md-2 pb-4">
                    <div>
                        <SizeTableHeader>
                            {_t('woman')}
                        </SizeTableHeader>
                        <SizeTable>
                            <tbody>

                                <tr>
                                    <td className="st-blank"></td>
                                    <td className="st-th">50 kg</td>
                                    <td className="st-th">60 kg</td>
                                    <td className="st-th">70 kg</td>
                                    <td className="st-th">80 kg</td>
                                    <td className="st-th">90 kg</td>
                                    <td className="st-th">100 kg</td>
                                    <td className="st-th">&gt;100 kg</td>
                                </tr>
                                <tr>
                                    <td className="st-th">150 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                    <td className="st-td st-h4">H4</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">160 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">170 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">180 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">190 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">200 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">&gt;200 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                            </tbody>

                        </SizeTable>


                    </div>
                    <div>
                        <SizeTableHeader>
                            {_t('man')}
                        </SizeTableHeader>


                        <SizeTable>
                            <tbody>

                                <tr>
                                    <td className="st-blank"></td>
                                    <td className="st-th">50 kg</td>
                                    <td className="st-th">60 kg</td>
                                    <td className="st-th">70 kg</td>
                                    <td className="st-th">80 kg</td>
                                    <td className="st-th">90 kg</td>
                                    <td className="st-th">100 kg</td>
                                    <td className="st-th">&gt;100 kg</td>
                                </tr>
                                <tr>
                                    <td className="st-th">150 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                    <td className="st-td st-h4">H4</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">160 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">170 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">180 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">190 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">200 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h3">H3</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                                <tr>
                                    <td className="st-th">&gt;200 cm</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h2">H2</td>
                                    <td className="st-td st-h4">H4</td>
                                </tr>
                            </tbody>

                        </SizeTable>

                    </div>

                </div>

            </div>


        </Modal>


        {/* Twardość - jaką wybrać? */}
        <Modal
            className="modal"
            onClose={e => {
                store.closeVideoPopup();
            }}
            isOpen={store.isVideoPopupOpen}

        >
            <div className="ModalVideo">
                <div className='c-h1 mb-4'>{_t('video_fabric_question')}</div>


                <iframe style={{ width: "100%", aspectRatio: "16 / 10.66", height: "auto", border: 0 }} width="560" height="315" src={`${store.videoPopupUrl ? store.videoPopupUrl : _t('default_video_url')}?&amp;autoplay=1&mute=1`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

            </div>


        </Modal>

        {/* Saving popup */}
        <SavingModal mode="bottom" />

        {/* Cart Summary popup */}
        <CartSummaryModal defaultCategoryId={store.defaultCategoryId} />

        {/* Summary popup */}
        <SummaryModal />

        {/* Preview popup */}
        <PreviewModal />

        {/* SliderModal popup */}
        <SliderModal />

        {/* SliderModal popup */}
        <MattressDetailModal />

        {/* QuizModal popup */}
        <QuizModal />

        <TechnicalCardModal category={store.selectedCategory} />

        <Modal
            className="modal-alert"
            onClose={e => {
                store.closeOnExit();
            }}
            isOpen={store.isOnExitOpen}

        >
            <div className="c-h-big">{_t('break_title')}</div>
            <p>{_t('break_desc')}</p>
            <div className="d-flex f-col g-1">
                <Button
                    className="primary w-100"
                    onClick={e => {
                        store.closeOnExit();
                        store.openSavingPopup();
                    }}>
                    {_t('save_project')}
                </Button>
                <Button
                    className="primary hollow w-100"
                    onClick={() => {
                        store.closeConfigurator();


                    }}>
                    {_t('close_no_save')}
                </Button>

            </div>
        </Modal>


    </>
});

Modals.displayName = "Modals";
export default Modals;

